import React, { useContext } from 'react'
import moment from 'moment'
import LazyLoad from 'react-lazyload'
import { Col, Row, Grid } from 'react-flexbox-grid'
import { Spinner } from 'media/icons'
import alphabetSort from 'helpers/alphabetSort'
import useShopStatistics from 'hooks/useShopStatistics'
import BranchItem from './components/BranchItem'
import { DashboardContext } from 'components/DashboardContext'
import { StyledBranchList } from './components/styled'
import { LoadingWrapper } from 'style/styled'
import Header from './components/Header'
import { getCRsIdsFromBranchList } from 'helpers/getCRsIdsFromBranchList'

const Dashboard = () => {
	const {
		branchList = [],
		activeDate,
		mainCurrency,
		selectedRegion,
		setSelectedRegion,
		regionList = [],
		searchInput,
		dateIsToday
	} = useContext(DashboardContext)

	const formatedDate = moment(activeDate).format('YYYY-MM-DD')

	const allowedShopsIds = branchList
		.filter(branch => branch.cashRegisters.some(cr => cr.isAvailableInWebApp))
		.map(branch => branch.id)

	const branchListDisplayed = branchList
		.filter((item) =>
			item.cashRegisters.some((el) => el.isAvailableInWebApp) &&
			(!selectedRegion || item.regionId === selectedRegion) &&
			(!searchInput || (item.name.toLowerCase()).includes(searchInput.toLowerCase()))
		)
		.sort(alphabetSort)

	const cashRegisterIds = getCRsIdsFromBranchList(branchList)

	const { branchList: branchListWithStatistics, loading: isLoading, error } = useShopStatistics({
		branchList: branchListDisplayed,
		cashRegisterIds,
		date: formatedDate,
		dateIsToday
	})

	return (
		<>
			<Header
				selectedRegion={selectedRegion}
				setSelectedRegion={setSelectedRegion}
				regionList={regionList}
				branchList={branchList}
				allowedShopsIds={allowedShopsIds}
			/>
			<StyledBranchList>
				<Grid className='defaultGrid'>
					<Row className='row branchListRow'>
						{(() => {
							if(error) {
								return `Error! ${error.message}`
							}
							if(isLoading) {
								return(
									<LoadingWrapper>
										<Spinner />
									</LoadingWrapper>
								)
							}
							return branchListWithStatistics?.map((branch) => (
								<Col className='col' xl={3} md={3} sm={6} xs={6} key={branch.id}>
									<LazyLoad
										className='lazyloadWrapper'
										height={'90%'}
										once
										resize
									>
										<BranchItem
											currency={mainCurrency}
											shop={branch}
										/>
									</LazyLoad>
								</Col>
							))
						})()}
					</Row>
				</Grid>
			</StyledBranchList>
		</>
	)
}

export default Dashboard
